<div class="data result-container">
    <div style="flex: 1">
        <div>
            <span>{{ overlappingMission.name }}</span>
            <span class="left-buffer text-muted">
                ({{ overlappingMission.organisationName }})
            </span>
        </div>
        <div class="horizontal-container">
            <div class="fill">
                {{
                    overlappingMission.missionDate
                        | formatDateTime: mission.timeZone
                }}
                - {{ endTime | formatDateTime: mission.timeZone }}
            </div>
            <div class="fill">
                SFC -
                {{ altitude | formatAltitudeValue: 'Unlimited' }}
            </div>
        </div>
    </div>
    <field-validation-indicator
        [valid]="isInformational || isAcknowledged"
        [customTooltip]="
            isInformational
                ? 'This conflicting mission is informational only'
                : isAcknowledged
                ? 'You have acknowledged this conflicting mission'
                : 'You have not acknowledged this conflicting mission'
        "
        class="pull-right"
    ></field-validation-indicator>
    <div>
        <button
            type="button"
            class="btn btn-xs btn-pill btn-primary left-buffer"
            tooltip="View and acknowledge conflicting mission"
            placement="top"
            (click)="viewOverlapDetail()"
        >
            {{ buttonText }}
        </button>
    </div>
</div>
